export default "__VITE_ASSET__BDKYe7By__"